import React, { useState,useEffect,useRef } from 'react';
import './classes/AddUser.css';
import './classes/UserTab.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SalespersonSidebar from './SalespersonSidebar';
import { configData } from "../config";
import Select from 'react-dropdown-select';
import { Helmet } from 'react-helmet';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import Editor, { 
  BtnBold,
  BtnItalic,
  BtnRedo,
  BtnUndo,
  Toolbar
} from 'react-simple-wysiwyg';
 import { format } from "date-fns";

const AddUserForm = () => {
  const initialForm = {
    userAssignment:'',
    userName:'',
    email:'',
    password:'',
    confirmPassword:'',
    status:'1',
    roles:['2'],
    firstName:'',
    lastName:'',
    team:'',
    organization_name:'',
    biography:'',
     placements: [{ page: '', order: '1' }],
    street:'',
    address:'',
    city:'',
    state:'',
    zip:'',
    country:'US',
    continent:'',
    linkedIn_url:'',
    primary_phone:'',
    secondary_phone:'',
    captcha:'',
    birthday:'',
    birthday_obj: null,
    appRegister_step:'1',
    pageURL: window.location.href
  };
 
  const [formData, setFormData] = useState(initialForm);
  const [errors, setErrors] = useState([]);
  const[success,setSuccess] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  //  const inputStyle = {
  //       border:fieldErrors.userName ? '2px solid red' : '1px solid #777',
  //       border:fieldErrors.email ? '2px solid red' : '1px solid #777',
  //       border:fieldErrors.password ? '2px solid red' : '1px solid #777',
  //       border:fieldErrors.confirmPassword ? '2px solid red' : '1px solid #777',
  //       border:fieldErrors.continent ? '2px solid red' : '1px solid #777',
  //       border:fieldErrors.captcha ? '2px solid red' : '1px solid #777'        
  //   };
  const inputStyle = {
  userName: {
    border: fieldErrors.userName ? '2px solid red' : '1px solid #777'
  },
  email: {
    border: fieldErrors.email ? '2px solid red' : '1px solid #777'
  },
  password: {
    border: fieldErrors.password ? '2px solid red' : '1px solid #777'
  },
  confirmPassword: {
    border: fieldErrors.confirmPassword ? '2px solid red' : '1px solid #777'
  },
  continent: {
    border: fieldErrors.continent ? '2px solid red' : '1px solid #777'
  },
  captcha: {
    border: fieldErrors.captcha ? '2px solid red' : '1px solid #777'
  }
};

 const [countriesList, setCountriesList] = useState([]);
   const [statelist, setStateList] = useState({});
  
const [selectedcountry, setSelectedCountry] = useState([{ label: 'United States', value: 'US' }]);
  const [selectedState, setSelectedState] = useState('');
  const [useEditor, setUseEditor] = useState(true);
  const [placements, setPlacements] = useState([{ page: '', order: '1' }]);
  const [pages, setPages] = useState([]); // fetched from DB
  const [captchaText, setCaptchaText] = useState('');
  const canvasRef = useRef(null);
  const [captchaSid, setCaptchaSid] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
  const [editorData, setEditorData] = useState("");
  const[salespersonList, setSalespersonList] = useState({});
  const[rolesList, setRolesList] = useState({});
  const app_url = configData.APP_URL;

    const getCurrentDateFormatted = () => {
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const yyyy = today.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };
  
  const currentFormattedDate = getCurrentDateFormatted();
 const [selectedRoles, setSelectedRoles] = useState(['2']);
 const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [strength, setStrength] = useState('');
  const [rules, setRules] = useState({
    length: false,
    lowercase: false,
    uppercase: false,
    number: false,
    special: false,
  });
const allRulesPassed =
  rules.length &&
  rules.lowercase &&
  rules.uppercase &&
  rules.number &&
  rules.special;

  const checkStrength = (val) => {
    const validations = {
      length: val.length >= 6,
      lowercase: /[a-z]/.test(val),
      uppercase: /[A-Z]/.test(val),
      number: /[0-9]/.test(val),
      special: /[!@#$%^&*(),.?":{}|<>_\-]/.test(val),
    };
    setRules(validations);

    const passed = Object.values(validations).filter(Boolean).length;
    if (passed <= 2) setStrength('Weak');
    else if (passed === 3 || passed === 4) setStrength('Fair');
    else setStrength('Strong');
  };

  const getIndicatorStyle = () => {
     if (password.length === 0) {
    return { backgroundColor: '#ccc', width: '100%' };
  }
    if (strength === 'Weak') return { backgroundColor: 'red', width: '45%' };
    if (strength === 'Fair') return { backgroundColor: 'orange', width: '75%' };
    return { backgroundColor: '#32cd32', width: '100%' };
  };
//  const handleBirthDateChange = (date,name) => {
       
//         if (date) {
          
//           const formattedDate = format(date, "yyyy-MM-dd"); // Example: 2025-06-21 11:03:00
      
//           setFormData({ ...formData, [name]: formattedDate })
          
//           // You can now use formattedDate for your application logic
//         }
//       };
  const BDateRef = useRef(null);
  const handleDateChange = (date, field) => {
    setFormData(prev => ({
        ...prev,
        [`${field}_obj`]: date,                   
        [field]: date ? format(date, 'yyyy-MM-dd') : '' 
    }));
  };
  useEffect(() => {
    retrieveCountriesList();
    retrieveStateList();
    getsalespersonlist(); 
    getroleslist(); 
    getplacementlist();
  }, []);
  const handleAddPlacement = () => {
  setFormData((prev) => ({
    ...prev,
    placements: [...prev.placements, { page: '', order: '1' }],
  }));
};

const handleDeletePlacement = (index) => {
  const updated = formData.placements.filter((_, i) => i !== index);
  setFormData((prev) => ({ ...prev, placements: updated }));
};

const handlePlacementChange = (index, field, value) => {
  const updated = [...formData.placements];
  updated[index][field] = value;
  setFormData((prev) => ({ ...prev, placements: updated }));
};
 const onEditorChange = (e) => {
    let newHtml = e.target.value;
    
    // Wrap raw plain text that isn't already in HTML
  if (!newHtml.startsWith('<')) {
    newHtml = `<p>${newHtml}</p>`;
  }
    // Remove trailing <br> if the content is otherwise empty
    if (newHtml === '<br>' || newHtml === '<p><br></p>') {
      newHtml = '';
    }
      
 
    setFormData((prev) => ({ ...prev, biography: newHtml }));
   
  };

const handleOpen = () => {
    setSelectedCountry([]);
    setFormData(prevState => ({
      ...prevState,
      country:''
    }));

  };
  // useEffect(() => {
  //   fetch('') // Replace with  actual URL
  //     .then((res) => res.json())
  //     .then((data) => setAgents(data))
  //     .catch((err) => console.error('Failed to fetch agents:', err));
  //   }, []);

  async function retrieveStateList() {
    const statelistresponse = await fetch(
      app_url+'smwwstates/getstatelist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const statelistdata = await statelistresponse.json();
    
    const statelist = {};
    Object.keys(statelistdata.data.result).forEach(function(key) {
      
      statelist[key] = statelistdata.data.result[key];
    
    });
    setStateList(statelist);
   
  }
  async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(
      app_url+'smwwcountries/getcountrieslist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const countrieslistdata = await countrieslistresponse.json();

    setCountriesList(countrieslistdata.data.result);
   
    
    
  }
  async function getsalespersonlist() {
    
         try {
            const response = await fetch(
                app_url+'user/getsalespersonlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        
  }
  async function getplacementlist() {
    
         try {
            const response = await fetch(
                app_url+'node/getnodepages',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setPages(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        
  }
  async function getroleslist() {
    
         try {
            const response = await fetch(
                app_url+'user/getroleslist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setRolesList(responsedata.data.result);
                console.log(rolesList.length);
               
            } 
        } catch (err) {
            
         }
        
  }
  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
    setSelectedState(''); 
  };

  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
  };

 
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Generate dynamic values on load
    const sid = Date.now().toString();
    const token = Math.random().toString(36).substr(2);
    setCaptchaSid(sid);
    setCaptchaToken(token);

    initializeCaptcha(ctx);
  }, []);

  const generateRandomChar = (min, max) =>
    String.fromCharCode(Math.floor(Math.random() * (max - min + 1) + min));

  const generateCaptchaText = () => {
    let captcha = '';
    for (let i = 0; i < 3; i++) {
      captcha += generateRandomChar(65, 90);   // A-Z
      captcha += generateRandomChar(97, 122);  // a-z
      captcha += generateRandomChar(48, 57);   // 0-9
    }
    return captcha.split('').sort(() => Math.random() - 0.5).join('');
  };

  const drawCaptchaOnCanvas = (ctx, captcha) => {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    const colors = ['#000', '#555'];
    const spacing = 150 / captcha.length;

    for (let i = 0; i < captcha.length; i++) {
      const x = 25;
      ctx.font = '20px Roboto Mono';
      ctx.fillStyle = colors[Math.floor(Math.random() * colors.length)];
      ctx.fillText(
        captcha[i],
        x + i * spacing,
        Math.floor(Math.random() * 16 + 25)
      );
    }
  };

  const initializeCaptcha = (ctx) => {
    setFormData((prev) => ({ ...prev, captcha: '' }));
    const newCaptcha = generateCaptchaText();
    setCaptchaText(newCaptcha);
    drawCaptchaOnCanvas(ctx, newCaptcha);
  };


const [state, setState] = React.useState({ value: null });

 const validateForm = () => {
  const newFieldErrors = {};
  const newMessages = [];

    // Username
if (!formData.userName) {
  newFieldErrors.userName = true;
  newMessages.push('Username field is required.');
} else {
  if (formData.userName.startsWith(' ')) {
    newFieldErrors.userName = true;
    newMessages.push('The username cannot begin with a space.');
  }

  // const isEmail = /^\S+@\S+\.\S+$/;
  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isName = /^[a-zA-Z][a-zA-Z\s\.\-']*$/;

  if (!isEmail.test(formData.userName) && !isName.test(formData.userName)) {
    newFieldErrors.userName = true;
    newMessages.push('Username must be a valid name or email address.');
  }
}

  // Email
  if (!formData.email) {
    newFieldErrors.email = true;
    newMessages.push('E-mail address field is required.');
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    newFieldErrors.email = true;
    newMessages.push('Invalid Email Format.');
  }

  // Password
  if (!formData.password) {
    newFieldErrors.password = true;
    newMessages.push('Password field is required.');
  }
if (!formData.confirmPassword) {
  newFieldErrors.confirmPassword = true;
  newMessages.push('Confirm Password field is required.');
} else if (formData.password !== formData.confirmPassword) {
  newFieldErrors.confirmPassword = true;
  newMessages.push('Password and Confirm Password should match.');
}

  // Continent
  if (!formData.continent) {
    newFieldErrors.continent = true;
    newMessages.push('Continent field is required.');
  }

// CAPTCHA Validation
if (!formData.captcha) {
  newFieldErrors.captcha = true;
  newMessages.push('What code is in the image? field is required.');
} else if (formData.captcha.trim() !== captchaText.trim()) {
  newFieldErrors.captcha = true;
  newMessages.push('The CAPTCHA code entered is incorrect.');
}
if(formData.linkedIn_url !== null) {
    if(formData.linkedIn_url.trim() !== '') {
      var linkedinurl = formData.linkedIn_url.toLowerCase();
      if (linkedinurl.includes("linkedin.com/") === false) {
        newFieldErrors.linkedIn_url = true;
       newMessages.push('Please enter a valid LinkedIn URL');
        
      }
     }
    }


  setFieldErrors(newFieldErrors); 
  setErrors(newMessages);         
  return newMessages.length === 0;
};




  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log('Submitted Data:', formData);
  //   // You can send data to API here
  // };
  const handleRolesChange = (e) => {
  const { value, checked } = e.target;
  
};

//  const handleChange = (e) => {
//     const { name, value } = e.target;
//      if(e.target.name === 'roles') {
//     const isChecked = e.target.checked;
//       if(isChecked){
//       setFormData(prevState => ({
//         ...prevState,
//         roles: [...formData.roles, e.target.value],
        
//       }));
//     } else {
//       let index = formData.roles.indexOf(e.target.value);
//       formData.roles.splice(index, 1);
//       setFormData(prevState => ({
//         ...prevState,
//         roles: formData.roles,
        
//       }));
//     }
    
//   } else {
//     setFormData({ ...formData, [name]: value });
//   }
//   };
const handleChange = (e) => {
  const { name, value, checked } = e.target;

  if (name === 'roles') {
    setFormData(prev => {
      let updated = [...prev.roles];

      if (checked && !updated.includes(value)) {
        updated.push(value);
      } else if (!checked && value !== '2') {
        updated = updated.filter(r => r !== value);
      }

      return {
        ...prev,
        roles: updated
      };
    });
  } else {
    // For all other fields like name, email, etc.
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }
};


 const handleSubmit = async (e) => {
  e.preventDefault();
  if (validateForm()) {
    const response = await fetch(app_url+'user/adduser', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
       if(data.data.result === "user_created") {
         alert('User added successfully!');
         setSuccess(data.data.msg);
          setFormData(initialForm);
          setPassword('');
         window.scrollTo(0, 0);
       }
       else if(data.data.result === "error") {
        setErrors(data.data.msg);
        window.scrollTo(0, 0);
       }

  }
   else {
      
      window.scrollTo(0, 0);
    }
};

  return (
     <div id="main" className='adduser-main'>  
      <Helmet><title>Add User</title></Helmet>    
        <div class="left"></div>
		
         <div class="center left-center">
             <div className='adduser-form-container' >
            {errors.length > 0 && (
          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`}}>
           {errors.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
        {success && (
          <div className="set-message-done">
            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span dangerouslySetInnerHTML={{__html: success}}></span>
          </div>
          
       
        )}
                <div className='adduser-block'>
                  <p>This web page allows administrators to register new users. Users' e-mail addresses and usernames must be unique.</p>
                </div>
                <div>
                  <form onSubmit={handleSubmit}>
                          <div className='user-assign-field'>
                              <label>User Assignment </label>
                              
                               <select
                               className='.adduser-form-item '
                                name="userAssignment"
                                value={formData.userAssignment}
                                onChange={handleChange}                              >
                                 <option value=""></option>
                                {salespersonList.length > 0 && (
                                  <>
                                    {salespersonList.map((item, index) => {
                                        return <>
                                          {item['uid'] != null && (
                                            <><option value={item['uid']}>{item['name']}</option></>
                                          )}
                                      </>
                    
                                    })}  
           
                                  </>
                                )}
                               
                              </select>

                          </div>
                      <div className='adduser-form-wrapper'>
                          <div className="adduser-form-item">
                                <div id="username-input">
                              <label>Username  <span className="form-required" title="This field is required.">*</span></label>
                              <input
                                type="text"
                                name="userName"
                                value={formData.userName}
                                onChange={handleChange}
                                className={fieldErrors.userName ? 'input-error' : ''}
                                style={inputStyle.userName}

                              />
                              </div>
                              </div>
                              <div className="adduser-description">
                              <p>Spaces are allowed; punctuation is not allowed except for periods, hyphens, apostrophes, and underscores.</p>
                              </div>
                          
                          <div className="adduser-form-item">
                              <label>
                              Email address <span className="form-required" title="This field is required.">*</span> </label>
                               <input
                                type="text"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={fieldErrors.email ? 'input-error' : ''}
                                style={inputStyle.email}

                              />  
                              </div>
                              <div className="adduser-description">
                              <p>A valid e-mail address. All e-mails from the system will be sent to this address. The e-mail address is not made public and will only be used if you wish to receive a new password or wish to receive certain news or notifications by e-mail.</p>
                              </div>
                          
                             <div className="adduser-password-confirm">
                                      {/* Password strength visual box */}
                                      <div className="adduser-form-item-password">
                                        <div className="adduser-password-strength">                                         
                                          <div className="adduser-password-strength-title">Password strength: <span className="adduser-password-strength-text">{strength}</span></div>
                                          <div className="adduser-password-indicator">
                                            <div className="adduser-indicator" style={{ height: '5px', ...getIndicatorStyle() }}></div>
                                          </div>
                                        </div>
                                      </div>

                                      {/* Password input */}
                                      <div className="adduser-password-field">
                                        <label>
                                          Password <span className="form-required" title="This field is required.">*</span>
                                        </label>
                                        <input
                                          type="password"
                                          name="password"
                                          value={password}
                                          onChange={(e) => {                                            
                                            const val = e.target.value;
                                            setPassword(val);
                                            setFormData(prev => ({ ...prev, password: val })); 
                                            checkStrength(val);
                                          }}
                                          
                                          className={fieldErrors.password ? 'input-error' : ''}
                                          style={inputStyle.password}

                                        />
                                      </div>

                                      {/* Match status */}
                                      {confirmPassword.length > 0 &&
                                      <div className="adduser-password-confirm adduser-form-item-password" style={{ marginTop: '10px', fontWeight: 'bold' }}>
                                        <div className='adduser-password-match'>
                                        Passwords match:{' '}
                                        {confirmPassword.length > 0 ? (
                                          password === confirmPassword ? (
                                            <span style={{ color: 'green' }}>Yes</span>
                                          ) : (
                                            <span style={{ color: 'red' }}>No</span>
                                          )
                                        ) : (
                                          <span style={{ color: 'gray' }}></span>
                                        )}
                                      </div>
                                      </div>
                                        }
                                      {/* Confirm Password */}
                                      <div className="adduser-cofirm-password-field">
                                        <label>
                                          Confirm password <span className="form-required" title="This field is required.">*</span>
                                        </label>
                                        <input
                                            type="password"
                                            name="confirmPassword"
                                            value={formData.confirmPassword}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              setFormData({ ...formData, confirmPassword: value });
                                              setConfirmPassword(value);
                                            }}
                                           
                                            className={fieldErrors.confirmPassword ? 'input-error' : ''}
                                            style={inputStyle.confirmPassword}

                                          />
                                      </div>

                                      {/* Dynamic Description */}
                                {password.length > 0 && !allRulesPassed && (
                                  <div className="adduser-description1 adduser-password-conditions">
                                    <p>To make your password stronger:</p>
                                    <ul>
                                      {!rules.length && (
                                        <li style={{ listStyleType: "disc" }}>Make it at least 6 characters</li>
                                      )}
                                      {!rules.lowercase && (
                                        <li style={{ listStyleType: "disc" }}>Add lowercase letters</li>
                                      )}
                                      {!rules.uppercase && (
                                        <li style={{ listStyleType: "disc" }}>Add uppercase letters</li>
                                      )}
                                      {!rules.number && (
                                        <li style={{ listStyleType: "disc" }}>Add numbers</li>
                                      )}
                                      {!rules.special && (
                                        <li style={{ listStyleType: "disc" }}>Add punctuation</li>
                                      )}
                                    </ul>
                                  </div>
                                )}

                                        <div className='adduser-description1'>Provide a password for the new account in both fields.</div>
                         </div>
                        <div className="adduser-form-item">
                            <label>Status</label>
                            <div className="adduser-form-radios">
                              <div className="adduser-form-type-radio">
                                <label>
                                  <input
                                    type="radio"
                                    name="status"
                                    value="0"
                                    checked={formData.status === '0'}
                                    onChange={handleChange}
                                  /><span className='adduser-radiolabel'>Blocked</span>
                                </label>
                              </div>
                              <div className="adduser-form-type-radio">
                                <label>
                                  <input
                                    type="radio"
                                    name="status"
                                    value="1"
                                    checked={formData.status === '1'}
                                    onChange={handleChange}
                                  /> <span className='adduser-radiolabel'>Active</span>
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="adduser-form-item">
                              <label>Roles</label>
                              <div className="adduser-form-type-checkbox">
                               {/* {rolesList.length > 0 && (
                                  <>
                                {rolesList.map((role,index) => (
                                  <label key={role['name']}>
                                    <input
                                      type="checkbox"
                                      name="roles"
                                      value={role['id']}
                                     //checked={selectedRoles.includes(role['id'])}
                                      disabled={selectedRoles.includes(role['id'])} // make it readonly
                                      onChange={handleChange}
                                    />
                                    <span className="adduser-checkboxlabel">{role['name']}</span>
                                  </label>
                                ))}
                                </>
                              )}*/}
                       {Array.isArray(rolesList) && rolesList.map((role) => {
                                const isAuthenticated = role.id === 2 || role.id === '2';

                                return (
                                  <label key={role.id}>
                                    <input
                                      type="checkbox"
                                      name="roles"
                                      value={role.id}
                                      checked={isAuthenticated || formData.roles.includes(String(role.id))}
                                      disabled={isAuthenticated}
                                      onChange={handleChange}
                                    />
                                    <span className="adduser-checkboxlabel">{role.name}</span>
                                  </label>
                                );
                         })}

                          </div>
                              
                              

                              <div className="adduser-form-item adduser-form-type-checkbox">
                                  <input
                                  type="checkbox"
                                  name="notify"
                                  id='notify'
                                  />
                                  <label className="option" htmlFor='notify'><span className='adduser-checkboxlabel'>Notify user of new account</span>
                                  </label>
                              
                              </div>
                          </div>
                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="first_name">First Name</label>
                          <input className='' type="text" id="first_name" name="firstName" value={formData.firstName} onChange={handleChange} />
                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="last_name">Last Name</label>
                          <input className='' type="text" id="last_name" name="lastName" value={formData.lastName} onChange={handleChange}  /> 
                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="team">What team/organization are you with?</label>
                          <input className='' type="text" id="team" name="team"  value={formData.team} onChange={handleChange} />  
                      </div>
                      <div className="adduser-form-item">
                          <div>
                              <label htmlFor="biography">Biography</label>
                              {useEditor ? (
                              <Editor
                                containerProps={{ style: { resize: 'vertical' } }}
                                value={formData.biography} 
                              //   onChange={(e) =>
                              //              setFormData((prev) => ({ ...prev, biography: e.target.value }))
                              // }
                              onChange={onEditorChange}
                              >
                              </Editor>

                       
                           ) : (
                            <>
                              <textarea
                                name="biography"
                                value={formData.biography}

                                onChange={handleChange}
                                placeholder="Write something awesome..."
                                rows={6}
                                // style={{ width: "100%" }}
                              />
                              <div className="grippie" style={{
                                background: `#eee url(${process.env.PUBLIC_URL}/images/grippie.png) no-repeat center 2px`,
                                }}>
                              </div>
                            </>
                          )}
                          <a className='editor-switcher' onClick={() => setUseEditor(!useEditor)}>
                            Switch to {useEditor ? "Plain Text Editor" : "Rich Text Editor"}
                          </a>
                      </div>
                      </div>
                      <div className="">    
                   <fieldset style={{border:0, padding: 0}}>
                    <legend><span>Placements</span></legend>
                    <div className="adduser-fieldset-wrapper">
                      <table>
                        <thead>
                          <tr>
                            <th style={{ width: '50%' }}>Page</th>
                            <th style={{ width: '30%' }}>Sort Order</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.placements.map((placement, index) => (
                            <tr key={index}>
                              <td>
                                <select
                                  name={`placement_page_${index}`}
                                  value={placement.page}
                                  onChange={(e) =>
                                    handlePlacementChange(index, 'page', e.target.value)
                                  }
                                  className='adduser-placement-select'
                                >
                                  <option value="">Select a page</option>
                                  {pages.length > 0 && (
                                  <>
                                  {pages.map((item, index) => (
                                    <option key={item['id']} value={item['id']}>
                                      {item['title']}
                                    </option>
                                  ))}
                                  </>
                                )}
                                </select>
                              </td>
                              <td>
                                <select
                                  name={`placement_sort_order_${index}`}
                                  className="adduser-form-select"
                                  value={placement.order}
                                  onChange={(e) =>
                                    handlePlacementChange(index, 'order', e.target.value)
                                  }
                                >
                                  {[...Array(30)].map((_, i) => (
                                    <option key={i + 1} value={i + 1}>
                                      {i + 1}
                                    </option>
                                  ))}
                                </select>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className='quick-links-reg-button'
                                  onClick={() => handleDeletePlacement(index)}
                                  //disabled={formData.placements.length === 1}
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleAddPlacement();
                        }}
                      >
                        +Add
                      </a>
                    </div>
                  </fieldset>


                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="street_address">Street Address</label>
                          <input
                            className=""
                            type="text"
                            id="street"
                            name="street"
                            value={formData.street}
                            onChange={handleChange}
                          /> 
                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="address">Address (cont.)</label>
                           <input
                            className=""
                            type="text"
                            id="address"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                          />
                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="city_town">City/Town</label>
                         <input
                              className=""
                              type="text"
                              id="city"
                              name="city"
                              value={formData.city}
                              onChange={handleChange}
                            />
                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="state_province">State/Province</label>
                          <select className='smww-appn' id="state" name="state" value={formData.state}  onChange={handleChange} >
            <option value="">Select State</option>
            {Object.keys(statelist).map(state => {
              return <option key={statelist[state].name} value={statelist[state].name}>{statelist[state].name}</option>
            })}
            </select>

                       
                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="zip_postalcode">Zip/Postal Code</label>
                           <input
                            className=""
                            type="text"
                            id="zip"
                            name="zip"
                            value={formData.zip}
                            onChange={handleChange}
                          />
                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="country">Country</label>
                        
                            <Select 
                             
                             id="country" name="country" className='select-country smww-appn'
                             searchable={true}
                             
                             clearable={true} 
                             clearOnBlur={true} 
                             clearOnSelect={true}
                             backspaceDelete={true} 
                             
                             style={{backgroundColor:'#ffffff', width:'87.8%', borderRadius: 5}}
                                                
                             options={countriesList} 
                             
                             onChange={(val) => {
                               if(val.length == 0) {
                                 console.log(val);
                               }
                               else{
                                 setSelectedCountry(val);
                               handleChange(
                                 { target: { value: val[0]['value'], name: 'country' } }
                               )
                               
                               }}
                             }
                             onDropdownOpen={handleOpen}
                             values={selectedcountry} 
                             
                             />
                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="continent">Continent <span className="form-required" title="This field is required.">*</span></label>
                            <select
                              id="continent"
                              name="continent"
                              className={`adduser-form-select ${fieldErrors.continent ? 'input-error' : ''}`}
                              value={formData.continent}
                              onChange={handleChange}
                              style={inputStyle.continent}

                            >
                               <option value="">- Select a Continent -</option>
                              <option value="4">Asia</option>
                              <option value="5">Africa</option>
                              <option value="7">North America</option>
                              <option value="2">South America</option>
                              <option value="3">Europe</option>
                              <option value="6">Australia/Oceania</option>
                          </select>
                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="linkedin_url">LinkedIn URL</label>
                          <div>
                               <textarea
                                    className="adduser-form-textarea resizable-textarea"
                                    type="text"
                                    id="linkedIn_url"
                                    name="linkedIn_url"
                                    cols={60}
                                    rows={5}
                                    value={formData.linkedIn_url}
                                    onChange={handleChange}
                                  ></textarea>
                              <div className="grippie" style={{
    background: `#eee url(${process.env.PUBLIC_URL}/images/grippie.png) no-repeat center 2px`,
  }}></div>
                          </div>
                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="primary_phone">Primary Phone</label>
                            <input
                              type="text"
                              id="primary_phone"
                              name="primary_phone"
                              value={formData.primary_phone}
                              onChange={handleChange}
                              size="60"
                              maxLength="100"
                            />
                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="secondary_phone">Secondary Phone</label>
                           <input
                              type="text"
                              id="secondary_phone"
                              name="secondary_phone"
                              value={formData.secondary_phone}
                              onChange={handleChange}
                              size="60"
                              maxLength="100"
                            />
                      </div>
                      <div className="adduser-form-item">
                          {/* <div className="adduser_captcha">
                              <img src="#" alt="Captcha" style={{ width: '180px', height: '60px' }}/>
                          </div>
                              <label>
                              What code is in the image? <span className="form-required" title="This field is required.">*</span>
                              </label>
                              <input
                              type="text"
                              name="adduser_captcharesponse"
                             
                              />
                              <div className="description"><p>Enter the characters shown in the image.</p></div> */}
                             <div className="adduser-captcha">
                                {/* Hidden fields to simulate original behavior */}
                               <input type="hidden" name="captcha_sid" value={captchaSid} />
                              <input type="hidden" name="captcha_token" value={captchaToken} />

                                <canvas
                                  ref={canvasRef}
                                  width="180"
                                  height="60"
                                  title="Image CAPTCHA"
                                  style={{ display: 'block', border: '1px solid white', marginBottom: '10px',backgroundColor:'white' }}
                                ></canvas>

                                <div className="adduser-form-item adduser-form-type-textfield adduser-form-item-captcha-response">
                                  <label htmlFor="edit-captcha-response">
                                    What code is in the image? <span className="form-required">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    id="edit-captcha-response"
                                    name="captcha_response"
                                    // value={userInput}
                                    value={formData.captcha}
                                    onChange={(e) =>
                                      setFormData({ ...formData, captcha: e.target.value })
                                    }
                                    size="15"
                                    maxLength="128"
                                    className={`adduser-form-text required ${fieldErrors.captcha ? 'input-error' : ''}`}
                                    autoComplete="off"
                                    style={inputStyle.captcha}

                                  />
                                  <div className="adduser-description1">Enter the characters shown in the image.</div>
                                </div>
                              </div>
                      </div>
                      <div className="adduser-form-item">
                          <fieldset  style={{border:0, padding:0}}>
                              <div>
                                  <legend>
                                      <span>Birthday</span>
                                  </legend>
                                  <div className='adduser-bday-date'>
                                      <label htmlFor="birthday">Date</label>
                                      <DatePicker
                                        ref={BDateRef}
                                        // selected={formData.birthday}
                                        // onChange={(date) => handleBirthDateChange(date,'birthday')}
                                        selected={formData.birthday_obj}
                                        onChange={(date) => {
                                          handleDateChange(date, "birthday");
                                          setTimeout(() => {
                                              const input = BDateRef.current?.input;
                                              if (input) {
                                              const len = input.value.length;
                                              input.setSelectionRange(len, len);
                                              }
                                          }, 0);
                                        }}
                                        dateFormat="MM/dd/yyyy"
                                        placeholderText={currentFormattedDate}
                                        id="birthday"
                                        name="birthday"
                                        className="adduser-form-control"
                                      />
                                      <div className="adduser-description1">Eg., {currentFormattedDate}</div>
                                  </div>
                                  
                              </div>
                          </fieldset>
                      </div>
                      <div className="adduser-form-item">
                          <label htmlFor="reg_step">App Register Step</label>
                           <select
                              id="appRegister_step"
                              name="appRegister_step"
                              className="adduser-register-select"
                              value={formData.appRegister_step}
                              onChange={handleChange}
                            >
                              <option value="_none">- None -</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                          </select>
                      </div>
                      <div className="adduser-form-actions">
                          <input type="submit" value="Create new account" className="quick-links-reg-button"  />
                      </div>

          </form>  
          
        </div>
      </div> 
      </div>
        <div class="right">

    <SalespersonSidebar/>
  </div> 
  <div className='clear'></div>
    
    
  </div>
  );
};

export default AddUserForm;